export default __webpack_public_path__ + "static/media/iconChannelMail.684d315c.svg";